import styled from 'vue3-styled-components';

export const ReturnTitle = styled.h2`
  text-align: left;
  color: #555;
  font-size: 20px;
  margin-bottom: 20px;
  font-weight: 600;

  &::before {
    content: '● ';
    margin-right: 5px;
    font-size: 18px;
  }
`;

export const ReturnTypeContainer = styled.div`
  margin: 20px 0;
  padding: 15px;
  background: #f9fafb;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
`;

export const ReturnTypeSelect = styled.select`
  width: 100%;
  height: 44px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  padding: 0 12px;
  font-size: 16px;
  transition: all 0.2s ease;
  background: #ffffff;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }

  &:required:invalid {
    color: #6b7280;
  }

  option[value=""][disabled] {
    display: none;
  }

  option {
    color: #374151;
  }
`;

export const TableContainer = styled.div`
  overflow-y: auto;
  max-height: 50vh;
  width: 100%;
  
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

export const ReturnTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #ffffff;
`;

export const ReturnTh = styled.th`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  background-color: #f2f2f2;
  font-weight: 600;
  font-size: 14px;
`;

export const ReturnTd = styled.td`
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
  font-size: 14px;
`;

export const ReturnCheckbox = styled.input`
  width: 20px;
  height: 20px;
  cursor: pointer;
  
  &:checked {
    accent-color: #2196F3;
  }
  
  &:hover {
    opacity: 0.8;
  }
`;

export const ReturnNoteContainer = styled.div`
  margin-top: 30px;
  width: 100%;
  position: relative;
`;

export const ReturnTextarea = styled.textarea`
  width: 100%;  
  height: 100px;
  resize: vertical;
  font-size: 15px;
  padding: 10px;
  border: 2px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s ease;
  background: #ffffff;

  &:focus {
    outline: none;
    border-color: #0f4c5c;
    box-shadow: 0 0 0 3px rgba(15, 76, 92, 0.1);
  }

  &::placeholder {
    color: #9ca3af;
  }
`;

export const ReturnNoteCount = styled.div`
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 12px;
  color: #666;
`;